import React, { useState, useEffect } from "react";
import CustomModal from "../../../common-utilities/core/modal";
import { Button, TextField, Grid, CircularProgress } from "@mui/material";
import Select from "react-select";
import { INDIAN_STATES_LIST } from "./config";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { REST_URLS } from "../../../common-utilities/utils/end-points/store-master";
import { HOSTNAME, INTRANETHOSTNAME } from "../../../common-utilities/utils/end-points";
import { toast } from "react-toastify";

export const GSTMappingModal = ({ showModal, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    state: null,
    gstN: "",
    gstId: null,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFetchingGST, setIsFetchingGST] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // Fetch existing GST when state is selected
  useEffect(() => {
    if (formData.state && showModal) {
      fetchExistingGST(formData.state.value);
    }
  }, [formData.state, showModal]);

  const fetchExistingGST = async (stateName) => {
    setIsFetchingGST(true);
   invokeApi(
        HTTP_METHODS.GET,
        `${INTRANETHOSTNAME}${REST_URLS.GET_STATE_GST}`,
        null,
        { q: stateName }
      ).then((response) => {
        if(!response.message){
            const data=response?.results[0]
 setFormData((prev) => ({
          ...prev,
          gstN: data?.gstN,
          gstId: data?.id || data?._id,
        }));
        if(data?.gstN){
        setIsUpdateMode(true);

        }
        } else {
        // No GST found, reset for new entry
        setFormData((prev) => ({
          ...prev,
          gstN: "",
          gstId: null,
        }));
        setIsUpdateMode(false);
      }
        setIsFetchingGST(false);
      }).catch(() => {
        setIsFetchingGST(false);
      });

      
    
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.state) {
      newErrors.state = "Please select a state";
    }
    
    if (!formData.gstN || formData.gstN.trim() === "") {
      newErrors.gstN = "GST Number is required";
    } 
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    
 
      const payload = {
        state: formData.state.value,
        gstN: formData.gstN.trim(),
      };

      
      if (isUpdateMode && formData.gstId) {
         invokeApi(
          HTTP_METHODS.PUT,
          `${INTRANETHOSTNAME}${REST_URLS.UPDATE_STATE_GST}${formData.gstId}`,
          payload,
          null
        ).then((res) => {
          if(res.message){
              toast.error(res?.message || "Failed to update GST Number", {
              autoClose: 2000,
            });
          }else{
            toast.success("GST Number updated successfully", { autoClose: 2000 });
            handleClose();
          }
     
          setIsSubmitting(false);
        }).catch(() => {
          setIsSubmitting(false);
        });
      } else {
        // Create new GST mapping using POST
     invokeApi(
          HTTP_METHODS.POST,
          `${INTRANETHOSTNAME}${REST_URLS.CREATE_STATE_GST}`,
          payload,
          null
        ).then((res) => {
          if(res.message){
 toast.error(res?.message || "Failed to map GST Number", {
              autoClose: 2000,
            });
          }else{
  toast.success("GST Number mapped successfully", { autoClose: 2000 });
            handleClose();
          }
     
          setIsSubmitting(false);
        }).catch(() => {
          setIsSubmitting(false);
        });
      }
  };

  const handleClose = () => {
    setFormData({
      state: null,
      gstN: "",
      gstId: null,
    });
    setErrors({});
    setIsUpdateMode(false);
    onClose();
  };

  if (!showModal) return null;

  return (
    <CustomModal onClose={handleClose} title={isUpdateMode ? "Update GST Number" : "Map GST Number"}>
      <div style={{ width: "500px", maxWidth: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}>
              Select State <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              options={INDIAN_STATES_LIST}
              placeholder="Choose a state..."
              value={formData.state}
              onChange={(selectedOption) => {
                setFormData({ 
                  ...formData, 
                  state: selectedOption,
                  gstN: "",
                  gstId: null
                });
                setErrors({ ...errors, state: null });
                setIsUpdateMode(false);
              }}
              isSearchable={true}
              isClearable={true}
              isDisabled={isFetchingGST}
              menuPortalTarget={document.body}
              onMenuOpen={(e) => e?.stopPropagation?.()}
              onMenuClose={(e) => e?.stopPropagation?.()}
              components={{
                ClearIndicator: (props) => (
                  <div onClick={(e) => e.stopPropagation()}>
                    {props.children}
                  </div>
                ),
              }}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                control: (base) => ({ ...base, minWidth: "100%" }),
              }}
            />
            {errors.state && (
              <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {errors.state}
              </span>
            )}
          </Grid>

          <Grid item xs={12}>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: 500 }}>
              GST Number <span style={{ color: "red" }}>*</span>
            
            </label>
            {isFetchingGST ? (
              <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px" }}>
                <CircularProgress size={20} />
                <span style={{ fontSize: "14px", color: "#666" }}>
                  Checking for existing GST...
                </span>
              </div>
            ) : (
              <TextField
                fullWidth
                size="small"
                placeholder="e.g., 24ABCDE1234F1Z5"
                value={formData.gstN}
                onChange={(e) => {
                  const value = e.target.value.toUpperCase();
                  setFormData({ ...formData, gstN: value });
                  setErrors({ ...errors, gstN: null });
                }}
                error={!!errors.gstN}
                helperText={errors.gstN}
                inputProps={{ maxLength: 15 }}
              />
            )}
          </Grid>

          <Grid item xs={12} style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isSubmitting || isFetchingGST}
              >
                {isSubmitting ? "Submitting..." : isUpdateMode ? "Update" : "Submit"}
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
};
